import getDeviceDetails from "./getDeviceDetails";
import getDeviceType from "./getDeviceType";

const DEFAULT_DEVICE_TYPE = "web";

const OS = {
  ANDROID: "Android",
  IOS: "iOS",
  UNKNOWN: "UNKNOWN",
};

const DeviceType = {
  All: "all",
  Other: "other",
  iPhone: "iphone",
  Android: "android",
  iPad: "ipad",
  Tablet: "tablet",
  MacBook: "macbook",
  Window: "window",
  Linux: "linux",
  Desktop: "desktop",
  Unknown: "Unknown",
  Mac: "mac",
  iOS: "ios",
};
export function getOsPlatform(deviceSystem) {
  const { deviceType } = getDeviceType(deviceSystem?.ua);
  const { category } = getDeviceDetails(deviceSystem?.ua);

  const _deviceType =
    deviceSystem?.device?.type ?? deviceType ?? DEFAULT_DEVICE_TYPE;

  if (_deviceType === DeviceType.Tablet || category === DeviceType.Tablet) {
    const osName = deviceSystem?.os?.name?.toLowerCase();
    if (
      osName?.includes(DeviceType.Mac) ||
      osName?.includes(DeviceType.iOS) ||
      osName?.includes(DeviceType.iPad)
    ) {
      return { os: OS.IOS, devicecategory: category };
    }
    return { os: OS.ANDROID, devicecategory: category };
  }

  return { os: deviceSystem.os.name ?? OS.UNKNOWN, devicecategory: category };
}
